import API from '@/API/API'

const MyAccountStore = {
  api: API,
  state: {
    currentUserId: '',
    user:{
      first_name:'',
      last_name:'',
      email:'',
      emailConfirmed:1
    }
  },
  reset:function() {
    this.state = {
      currentUserId: '',
      user:{
        first_name:'',
        last_name:'',
        email:'',
        emailConfirmed:1
      }
    }
  },
  getUser: function(success,error,maintenance){
    let self = this;
    this.api
    .getUser(this.state.currentUserId)
    .then(function (res) {
      self.state.loadedFavorites = true
      if (res.data) {
        let data = res.data
        if (data.error) {
          error(data.error)
        } else {
            if(data.maintenanceMode){
              maintenance()
              return
            }
            self.state.user = data.user
            self.state.user.password = ""
            success()
        }
      }else{
        error("Failed to get user")
      }
    })
    .catch(e => {
      error('An Error Occurred')
      self.state.loadedFavorites = true
    })
  },
  updateUser: function(success,error,maintenance){
    let self = this;
    this.api
    .updateUser(this.state.user)
    .then(function (res) {
      self.state.loadedFavorites = true
      if (res.data) {
        let data = res.data
        if (data.error) {
          error(data.error)
        } else {
            if(data.maintenanceMode){
              maintenance()
              return
            }
            success()
        }
      }else{
        error("Failed to update user")
      }
    })
    .catch(e => {
      error('An Error Occurred')
      self.state.loadedFavorites = true
    })
  },
  sendEmail: function(success,error,maintenance){
    let self = this;
    this.api
    .sendAccountEmail(this.state.user.id)
    .then(function (res) {
      self.state.loadedFavorites = true
      if (res.data) {
        let data = res.data
        if (data.error) {
          error(data.error)
        } else {
            if(data.maintenanceMode){
              maintenance()
              return
            }
            success()
        }
      }else{
        error("Failed to send email")
      }
    })
    .catch(e => {
      error('An Error Occurred')
      self.state.loadedFavorites = true
    })
  }
}

export default MyAccountStore



// WEBPACK FOOTER //
// ./src/components/account/MyAccountStore.js